import { render, staticRenderFns } from "./menuWeek.vue?vue&type=template&id=7472dd7d&scoped=true&"
import script from "./menuWeek.vue?vue&type=script&lang=js&"
export * from "./menuWeek.vue?vue&type=script&lang=js&"
import style0 from "./menuWeek.vue?vue&type=style&index=0&id=7472dd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472dd7d",
  null
  
)

export default component.exports